export default {
	install(Vue, options) {
		// Use on a component/element in place of @click: v-confirm=[modalOptionsObject, onConfirmCallback(args)]
		Vue.directive('confirm', {
			inserted(el, binding, vnode) {
				const listener = async () => {
					try {
						const confirm = await vnode.context.$msgBoxConfirm([
							binding.value[0].message,
							binding.value[0],
						]);
						if (confirm) {
							binding.value[1]();
						}
					} catch (e) {
						throw new Error(e);
					}
				};
				el.addEventListener('click', listener);
			},
			unbind(el) {
				// replace DOM element with cloned element to remove listener
				el.replaceWith(el.cloneNode(true));
			},
		});

		// Create an instance method
		// Used by the directive, but can be used as follows:
		// const confirmation = await this.$msgBoxConfirm(modalOptionsObject)
		// if (confirm) { do something }
		Vue.prototype.$msgBoxConfirm = function msgBoxConfirm(arg) {
			const globalModalOptions = {
				message: 'Put a message in the i18n json file.',
				centered: true,
				hideHeaderClose: false,
			};
			let msg;
			if (arg.constructor === Array) {
				msg = [arg[0], { ...globalModalOptions, ...arg[1] }];
			} else if (arg && typeof arg === 'object' && arg.constructor === Object) {
				msg = [arg.message, { ...globalModalOptions, ...arg }];
			}
			if (arg.ok) {
				return this.$bvModal.msgBoxOk(...msg);
			}
			return this.$bvModal.msgBoxConfirm(...msg);
		};
		Vue.prototype.$czm = function _czm() {
			if (!options.viewer) throw new Error('Need a name for Cesium component');
			let callback = null;
			const arr = [...arguments];
			if (typeof arr[arr.length - 1] === 'function') {
				callback = arr.pop();
			}
			const getChildren = () => {
				const childrenArray = [];
				const findChildren = (entityObj) => {
					if (entityObj.$children) {
						childrenArray.push(...entityObj.$children);
						entityObj.$children.map(findChildren);
					}
				};
				findChildren(this.$root);
				return childrenArray;
			};
			const cesiumViewer = getChildren().find((x) => x.$options.name === options.viewer);
			const [fn, ...args] = arguments;
			if (!(typeof fn === 'string' || fn instanceof String))
				throw new Error('First argument expected name of a function in Cesium component');
			if (!cesiumViewer[fn]) throw new Error('Not a function');
			const czmFn = args ? cesiumViewer[fn](...args) : cesiumViewer[fn]();
			return callback ? callback(czmFn) : czmFn;
		};
	},
};
